import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './../models/auth.service';
import { UserRoles, ApplicationRouteURL } from '../config';

@Injectable()
export class CAdminAuthGuard implements CanActivate {
  constructor(private authService: AuthService
    , private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    if (this.authService.isAuthorized(UserRoles.COMPANYADMIN)) {
      let urlBatchUpload = this.authService.GetURL(ApplicationRouteURL.URL_BATCHUPLOADPERSON);
      let urlDirectDebit = this.authService.GetURL(ApplicationRouteURL.URL_DIRECTDEBIT_LIST);
      let urlOrganizationUpdate = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_UPDATE);

      let urlTripDataReport = this.authService.GetURL(ApplicationRouteURL.URL_TRIPDATA_REPORT);
      let urlVehicleOccupancyReport = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT);
      let urlMaintenancePlanningReport = this.authService.GetURL(ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT);
      let urlRevenuePerVehicleReport = this.authService.GetURL(ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT);
      let urlSnailTrailReport = this.authService.GetURL(ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT);

      if (state.url == urlBatchUpload) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.PersonBatchUpload);
      } else if (state.url == urlDirectDebit) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.DirectDebitFile);
      } else if (state.url == urlOrganizationUpdate) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.CreateOrganization);
      } else if (state.url == urlTripDataReport) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.TRIP_DATA_REPORT);
      } else if (state.url == urlVehicleOccupancyReport) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.VEHICLE_OCCUPENCY_REPORT);
      } else if (state.url == urlMaintenancePlanningReport) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.MAINTAINANCE_PLANNING_REPORT);
      } else if (state.url == urlRevenuePerVehicleReport) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.REVENUE_PER_VEHICLE_REPORT);
      } else if (state.url == urlSnailTrailReport) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.SnailTrailReport);
      }
      else {
        return true;
      }
    } else {
      // Navigate to the login page
      this.router.navigate(['/Unauthorized']);
      return false;
    }

    // Store the attempted URL for redirecting 
    //this.authService.redirectUrl = state.url;

  }

  IsAuthorizeFor(moduleName: string) {
    return this.authService.IsAuthorizeFor(moduleName)
      .map(res => {
        if (!res.data) {
          this.router.navigate(['/NotFound']);
        }
        return res.data;
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/guard/auth-guard-cadmin.service.ts